import { buildWalze, updWalze } from '../entities/bosses/walze';
import { buildZenit, updZenit } from '../entities/bosses/zenit';
import { buildKathedrale, updKathedrale } from '../entities/bosses/kathedrale';
import { buildSichel, updSichel } from '../entities/bosses/sichel';
import { buildMutter, updMutter } from '../entities/bosses/mutter';
import { buildTurm, updTurm } from '../entities/bosses/turm';
import { buildSchlange, updSchlange } from '../entities/bosses/schlange';
import { buildZwilling, updZwilling } from '../entities/bosses/zwilling';
import { buildSpalter, updSpalter } from '../entities/bosses/spalter';
import { buildGerippe, updGerippe } from '../entities/bosses/gerippe';
import { buildKrone, updKrone } from '../entities/bosses/krone';
import { buildSpinne, updSpinne } from '../entities/bosses/spinne';
import { buildFlut, updFlut } from '../entities/bosses/flut';
import { buildWaage, updWaage } from '../entities/bosses/waage';
import { buildKokon, updKokon } from '../entities/bosses/kokon';
import { buildBrucke, updBrucke } from '../entities/bosses/brucke';
import { buildAugenwald, updAugenwald } from '../entities/bosses/augenwald';
import { buildNamenlos, updNamenlos } from '../entities/bosses/namenlos';
import { buildHohlraum, updHohlraum } from '../entities/bosses/hohlraum';
import { buildArmilla, updArmilla } from '../entities/bosses/armilla';
import { buildWirt, updWirt } from '../entities/bosses/wirt';
import { buildTiefe, updTiefe } from '../entities/bosses/tiefe';
import { buildStille, updStille } from '../entities/bosses/stille';
import { buildKaiser, updKaiser } from '../entities/bosses/kaiser';
import { buildChimare, updChimare } from '../entities/bosses/chimare';
import { buildRequiem, updRequiem } from '../entities/bosses/requiem';
import { buildWeltachse, updWeltachse } from '../entities/bosses/weltachse';
import { buildNichts, updNichts } from '../entities/bosses/nichts';
/* ============================================================
   23 隻 BOSS 的欄位表（造型以外的東西）
   ============================================================

   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 的 `BOSSES`
   機械移植。**不要手改**。

   欄位語意：`h`/`w` 是尺寸（與玩家機體同一把尺，機體全高約 4.5）、
   `tint` 是四色威脅語彙、`stages` 2 或 3（缺省視為 2）、
   `p2` 是兩階段的一句話、`pn[]` 是三階段的三句話、
   `breakName` 是可破壞部位（只有 WALZE 與 ZENIT 有，其餘是 '—'）。

   ⚠️ **這張表沒有戰鬥數值**（血量、傷害、招式）—— 原型是檢視台，
   它只有造型與動畫。戰鬥那一半在 `data/boss-stats.ts`，
   而且只有排進時刻表的那幾隻才有。 */

export var BOSSES: any[] = [
  {id:'walze', code:'WALZE', zh:'軋輥', role:'BOSS・地面壓迫', tint:'red',
     sil:'四足頂起的方形量體＋前犁', h:3.30, w:4.20, boss:1,
     spd:1.5, turn:0.9, gait:1.2, rng:5.5, tTel:1.10, tAtk:0.45, tRec:1.60,
     build:buildWalze, upd:updWalze,
     breakName:'左前腿＋砲塔核心'},
  {id:'zenit', code:'ZENIT', zh:'天頂', role:'BOSS・空中砲台', tint:'vio',
     sil:'浮空環＋四具垂莢', h:4.60, w:4.80, boss:1, fly:1,
     spd:1.1, turn:0.7, gait:1.0, rng:7.0, tTel:1.40, tAtk:0.85, tRec:1.80,
     build:buildZenit, upd:updZenit,
     p2:'環開至 5.4 倍・護罩全開（紫→核心）', breakName:'兩具砲莢'},
  {id:'kathedrale', code:'KATHEDRALE', zh:'大聖堂', role:'BOSS・移動要塞', tint:'amb',
     sil:'三片巨牆＋履帶座', h:9.00, w:11.00, boss:1, fam:'wall',
     spd:0.7, turn:0.4, gait:0.8, rng:9.0, tTel:1.50, tAtk:0.60, tRec:2.00,
     build:buildKathedrale, upd:updKathedrale,
     p2:'三牆外翻・核心露出（橙→紫）', breakName:'—'},
  {id:'sichel', code:'SICHEL', zh:'鐮', role:'BOSS・旋掃', tint:'red',
     sil:'雙足＋9.6 單位橫旋刃', h:5.60, w:9.60, boss:1, fam:'bar',
     spd:1.3, turn:0.8, gait:1.0, rng:4.6, tTel:0.95, tAtk:0.70, tRec:1.40,
     build:buildSichel, upd:updSichel,
     p2:'外刃甩脫・轉速三倍並開砲（紅→橙）', breakName:'—'},
  {id:'mutter', code:'MUTTER', zh:'母體', role:'BOSS・生成', tint:'azu',
     sil:'環形托架抱著巨球', h:7.60, w:8.20, boss:1, fam:'orb', fly:1,
     spd:0.6, turn:0.5, gait:0.8, rng:8.0, tTel:1.60, tAtk:0.90, tRec:2.00,
     build:buildMutter, upd:updMutter,
     p2:'四瓣外翻・核心直射（天藍→紫）', breakName:'—'},
  {id:'turm', code:'TURM', zh:'塔', role:'BOSS・攻城', tint:'vio',
     sil:'14 單位高的三節塔', h:14.00, w:3.60, boss:1, fam:'spike',
     spd:0.5, turn:0.5, gait:0.7, rng:11.0, tTel:1.70, tAtk:0.80, tRec:2.20,
     build:buildTurm, upd:updTurm,
     p2:'塔身前傾至水平・改掃射（紫→橙）', breakName:'—'},
  {id:'schlange', code:'SCHLANGE', zh:'蛇', role:'BOSS・節肢', tint:'red',
     sil:'13 節、22 單位長', h:2.60, w:22.00, boss:1,
     spd:1.8, turn:0.6, gait:1.0, rng:3.2, tTel:0.90, tAtk:0.60, tRec:1.30,
     build:buildSchlange, upd:updSchlange,
     p2:'節段分離浮空・各自射擊（紅→橙）', breakName:'—'},
  {id:'zwilling', code:'ZWILLING', zh:'雙生', role:'BOSS・複合雙體', tint:'red',
     sil:'兩具分離本體＋能量鏈', h:5.20, w:12.00, boss:1, stages:3,
     spd:1.2, turn:0.8, gait:1.0, rng:6.0, tTel:1.10, tAtk:0.55, tRec:1.40,
     build:buildZwilling, upd:updZwilling,
     pn:['P1 分離・各打各的（紅＋橙）','P2 靠攏・中間拉出能量鏈','P3 合體・核心露出（紫）'],
     breakName:'—'},
  {id:'spalter', code:'SPALTER', zh:'裂解者', role:'BOSS・分裂', tint:'vio',
     sil:'1→4→12 顆八面體', h:6.00, w:9.00, boss:1, stages:3, fly:1,
     spd:1.0, turn:0.9, gait:1.0, rng:6.5, tTel:1.20, tAtk:0.50, tRec:1.30,
     build:buildSpalter, upd:updSpalter,
     pn:['P1 單體・硬','P2 裂成四顆・包夾','P3 裂成十二顆・兩層公轉'],
     breakName:'—'},
  {id:'gerippe', code:'GERIPPE', zh:'骨籠', role:'BOSS・開合', tint:'vio',
     sil:'八根弧骨圍成的籠', h:7.00, w:6.80, boss:1, stages:3,
     spd:0.9, turn:0.7, gait:0.9, rng:5.5, tTel:1.30, tAtk:0.60, tRec:1.60,
     build:buildGerippe, upd:updGerippe,
     pn:['P1 籠閉合・核心打不到','P2 骨外張・核心全露但邊緣切人','P3 收攏成球・滾（紅）'],
     breakName:'—'},
  {id:'krone', code:'KRONE', zh:'冠冕', role:'BOSS・複合環', tint:'amb',
     sil:'10 單位大環＋八具掛載', h:6.60, w:10.40, boss:1, stages:3, fly:1,
     spd:0.9, turn:0.6, gait:0.9, rng:8.5, tTel:1.40, tAtk:0.60, tRec:1.70,
     build:buildKrone, upd:updKrone,
     pn:['P1 水平自轉・八具輪流開火','P2 傾斜 40°・半數關閉','P3 立起・變成滾動的輪'],
     breakName:'—'},
  {id:'spinne', code:'SPINNE', zh:'蛛', role:'BOSS・複合八足', tint:'red',
     sil:'八足撐開・身體極小', h:4.60, w:9.60, boss:1, stages:3,
     spd:1.6, turn:1.0, gait:1.3, rng:4.0, tTel:0.90, tAtk:0.55, tRec:1.20,
     build:buildSpinne, upd:updSpinne,
     pn:['P1 高站・腿下是陷阱','P2 蹲地・關節進入射程','P3 翻覆・腹部核心朝你（橙）'],
     breakName:'—'},
  {id:'flut', code:'FLUT', zh:'潮', role:'BOSS・聚形', tint:'red',
     sil:'56 個立方體的雲', h:8.00, w:11.00, boss:1, stages:3, fly:1,
     spd:1.4, turn:0.9, gait:1.0, rng:5.0, tTel:1.20, tAtk:0.70, tRec:1.50,
     build:buildFlut, upd:updFlut,
     pn:['P1 散成雲・打不完','P2 聚成錐・整根撞過來','P3 攤成牆・把場地切兩半'],
     breakName:'—'},
  {id:'waage', code:'WAAGE', zh:'天秤', role:'BOSS・不對稱', tint:'amb',
     sil:'桅杆＋一盾一砲的橫樑', h:7.20, w:11.00, boss:1, stages:3,
     spd:0.8, turn:0.6, gait:0.9, rng:9.0, tTel:1.50, tAtk:0.65, tRec:1.80,
     build:buildWaage, upd:updWaage,
     pn:['P1 平衡・盾永遠擋在砲的另一側','P2 盾落・整座往砲側傾倒','P3 雙臂垂下・橫樑變連枷'],
     breakName:'—'},
  {id:'kokon', code:'KOKON', zh:'繭', role:'BOSS・剝殼', tint:'vio',
     sil:'三層包覆的紡錘', h:7.60, w:6.40, boss:1, stages:3, fly:1,
     spd:0.7, turn:0.8, gait:0.9, rng:6.0, tTel:1.40, tAtk:0.55, tRec:1.60,
     build:buildKokon, upd:updKokon,
     pn:['P1 厚繭・極慢・幾乎打不穿','P2 外層剝落・開始會躲','P3 只剩核心・比小怪還小但抓不到'],
     breakName:'—'},
  {id:'brucke', code:'BRÜCKE', zh:'橋', role:'BOSS・複合雙柱', tint:'amb',
     sil:'拱門・玩家從下面穿過', h:8.60, w:14.00, boss:1, stages:3,
     spd:0.5, turn:0.4, gait:0.7, rng:10.0, tTel:1.60, tAtk:0.70, tRec:2.00,
     build:buildBrucke, upd:updBrucke,
     pn:['P1 站立・門下是唯一通道','P2 右柱折斷・整座傾斜','P3 倒下・變成橫躺的長堡壘'],
     breakName:'—'},
  {id:'augenwald', code:'AUGENWALD', zh:'眼林', role:'BOSS・複合十二眼', tint:'vio',
     sil:'幹上長十二顆眼', h:9.20, w:5.60, boss:1, stages:3,
     spd:0.6, turn:0.9, gait:0.8, rng:9.5, tTel:1.50, tAtk:0.75, tRec:1.90,
     build:buildAugenwald, upd:updAugenwald,
     pn:['P1 全開・沒有背面','P2 收成花苞・無敵但也不攻擊','P3 爆開成水平眼環・全部朝你'],
     breakName:'—'},
  {id:'namenlos', code:'NAMENLOS', zh:'無名', role:'BOSS・五重對稱', tint:'vio',
     sil:'五臂十五指・沒有一處二重對稱', h:8.40, w:9.20, boss:1, stages:3, deep:1,
     spd:0.8, turn:0.7, gait:0.9, rng:7.0, tTel:1.40, tAtk:0.70, tRec:1.80,
     build:buildNamenlos, upd:updNamenlos,
     pn:['P1 五臂垂下・緩慢','P2 五臂水平展開・十五指全張','P3 收成平躺的五芒星・旋轉'],
     breakName:'—'},
  {id:'hohlraum', code:'HOHLRAUM', zh:'空腔', role:'BOSS・無骨架', tint:'vio',
     sil:'十八片浮空板・中心是一個洞', h:7.80, w:8.40, boss:1, stages:3, deep:1, fly:1,
     spd:0.7, turn:0.6, gait:0.8, rng:7.5, tTel:1.50, tAtk:0.65, tRec:1.90,
     build:buildHohlraum, upd:updHohlraum,
     pn:['P1 板貼合成殼・像個機械','P2 板散開・洞變大','P3 板翻面穿過核心・把自己吞進去'],
     breakName:'—'},
  {id:'armilla', code:'ARMILLA', zh:'渾儀', role:'BOSS・不可能幾何', tint:'vio',
     sil:'七環七軸・互不對齊', h:8.40, w:8.60, boss:1, stages:3, deep:1, fly:1,
     spd:0.6, turn:0.8, gait:0.8, rng:8.0, tTel:1.60, tAtk:0.70, tRec:2.00,
     build:buildArmilla, upd:updArmilla,
     pn:['P1 軸對齊・像精密儀器','P2 軸各自漂移・儀器壞了','P3 環互相穿透・剛體做不到的事'],
     breakName:'—'},
  {id:'wirt', code:'WIRT', zh:'宿主', role:'BOSS・寄生', tint:'vio',
     sil:'熟悉的四足機甲＋不該長在那的東西', h:6.60, w:7.80, boss:1, stages:3, deep:1,
     spd:1.1, turn:0.8, gait:1.1, rng:5.5, tTel:1.20, tAtk:0.60, tRec:1.50,
     build:buildWirt, upd:updWirt,
     pn:['P1 機甲正常走・寄生體縮在背上','P2 寄生體張開・一條腿開始拖','P3 寄生體脫離升空・機甲癱在地上'],
     breakName:'—'},
  {id:'tiefe', code:'TIEFE', zh:'深淵', role:'BOSS・不完整的存在', tint:'vio',
     sil:'從地洞伸出的手臂・沒有身體', h:11.00, w:7.60, boss:1, stages:3, deep:1,
     spd:0.4, turn:0.6, gait:0.7, rng:6.5, tTel:1.30, tAtk:0.80, tRec:1.70,
     build:buildTiefe, upd:updTiefe,
     pn:['P1 單臂半握・緩慢橫掃','P2 臂伸長・指節全張','P3 第二隻臂從另一側伸出'],
     breakName:'—'},
  {id:'stille', code:'STILLE', zh:'靜默', role:'BOSS・不動', tint:'vio',
     sil:'10 單位死黑方尖碑＋十一片碎片', h:11.20, w:10.60, boss:1, stages:3, deep:1,
     spd:0.3, turn:0.5, gait:0.6, rng:9.0, tTel:1.80, tAtk:0.60, tRec:2.20,
     build:buildStille, upd:updStille,
     pn:['P1 完全靜止・只有瞬間轉向','P2 碎片加速・碑仍不動','P3 碑第一次真的動了'],
     breakName:'—'},
  {id:'kaiser', code:'KAISER', zh:'皇帝', role:'最終・機甲', tint:'amb',
     sil:'玩家機體的剪影 × 6.5 倍（同一份比例表）', h:24.00, w:15.00, boss:1, stages:3, fin:1,
     spd:0.9, turn:0.7, gait:0.9, rng:12.0, tTel:1.50, tAtk:0.70, tRec:1.90,
     build:buildKaiser, upd:updKaiser, camY:0.44,
     pn:['P1 立姿・遠距砲擊（橙）','P2 甩甲＋單膝跪地・從行走兵器變成固定砲台',
         'P3 上半身脫離・浮空（下半身癱在原地）'],
     breakName:'—'},
  {id:'chimare', code:'CHIMÄRE', zh:'奇美拉', role:'最終・八家族複合', tint:'vio',
     sil:'錐楔壁勺球桿翼環全長在一根脊椎上', h:16.00, w:20.00, boss:1, stages:3, fin:1,
     spd:0.8, turn:0.7, gait:0.9, rng:9.0, tTel:1.40, tAtk:0.70, tRec:1.80,
     build:buildChimare, upd:updChimare, camY:0.46,
     pn:['P1 八家族全在','P2 楔壁勺桿四肢剝落','P3 只剩球與環'],
     breakName:'—'},
  {id:'requiem', code:'REQUIEM', zh:'安魂曲', role:'最終・殘骸船', tint:'vio',
     sil:'船身嵌滿 24 具玩家機甲殘骸', h:22.00, w:14.00, boss:1, stages:3, fin:1, fly:1,
     spd:0.6, turn:0.5, gait:0.8, rng:11.0, tTel:1.70, tAtk:0.80, tRec:2.10,
     build:buildRequiem, upd:updRequiem, camY:0.40,
     pn:['P1 殘骸全暗','P2 上層八具亮起（綠）','P3 二十四具全亮 —— 綠色不再只屬於你'],
     breakName:'—'},
  {id:'weltachse', code:'WELTACHSE', zh:'世界軸', role:'最終・框不下', tint:'vio',
     sil:'48 單位的軸・看不到頂端', h:48.00, w:9.40, boss:1, stages:3, fin:1,
     spd:0.3, turn:0.4, gait:0.6, rng:14.0, tTel:2.00, tAtk:0.90, tRec:2.40,
     build:buildWeltachse, upd:updWeltachse, camY:0.16, fit:0.34,
     pn:['P1 只看得到最底下兩節','P2 下降十四單位','P3 再下降十四・頂端第一次進入畫面'],
     breakName:'—'},
  {id:'nichts', code:'NICHTS', zh:'虛無', role:'最終・空洞', tint:'vio',
     sil:'機甲形狀的洞・只有邊緣發光', h:20.00, w:9.60, boss:1, stages:3, fin:1, deep:1,
     spd:1.0, turn:0.9, gait:1.0, rng:8.0, tTel:1.30, tAtk:0.70, tRec:1.70,
     build:buildNichts, upd:updNichts, camY:0.44,
     pn:['P1 半亮的骨架','P2 四肢展開・邊緣全亮・空洞脹大','P3 頭部裂開・露出反向核心'],
     breakName:'—'}
];

/** id → 欄位表。 */
export var BOSS_BY_ID: Record<string, any> = {};
for (var _b = 0; _b < BOSSES.length; _b++) BOSS_BY_ID[BOSSES[_b].id] = BOSSES[_b];
